





















import { Component, Vue, Watch } from "vue-property-decorator";

import PaginatedSearch from "@/layouts/DashboardLayoutComponents/SoniprevPaginatedSearch.vue";
import CreationCard from "@/layouts/DashboardLayoutComponents/CreationCard.vue";
import FormField from "@/layouts/DashboardLayoutComponents/FormField.vue";


import UserModal from "./UserModal.vue";
import userModel from "@/models/user.model";
import specialtyModel from "@/models/specialty.model";
import sectorModel from "@/models/sector.model";

@Component({
	name: "users",
	components: {
		PaginatedSearch,
		UserModal,
		CreationCard,
		FormField,
	},
})
export default class Users extends Vue {
	entityModel: any;
	specialtyModel: any;
	sectorModel: any;

	schema: any = [];
	userId: string = "";
	entity: any = { userSectors: [{ 'sector.id': '', 'sector.specialty.id': '' }] };
	searchFilter = {
		role: { $ne: 'PROFESSIONAL' },
	};

	constructor() {
		super();
		this.specialtyModel = specialtyModel;
		this.sectorModel = sectorModel;
		this.entityModel = userModel;
	}

	async mounted() {
		this.userId = this.$route.params.id;
		this.schema = await userModel.getDescription();
	}

	openEntity(user: any) {
		this.$router.push(`/administrativo/usuarios/${user.id}`);
	}

	closeUserModal() {
		this.$router.push('.');
		(this.$refs.usersPaginatedSearch as any).refresh();
	}

	async create() {
		try {
			const entityToCreate = Object.assign({}, this.entity);
			if (!entityToCreate.userSectors[0]['sector.id']) {
				delete entityToCreate.userSectors;
			}
			await userModel.create(entityToCreate);
			this.$toasted.success('Usuário cadastrado');
			this.entity = { userSectors: [{ specialty: {} }] };
			(this.$refs.usersPaginatedSearch as any).refresh();
		} catch (error) {
			console.error(error);
			this.$toasted.error(error.friendlyMessage || 'Erro ao cadastrar usuário');
		}
	}

	@Watch("$route")
	updateRoute(route: any) {
		if (route.params.id) {
			this.userId = route.params.id;
		} else {
			this.userId = "";
		}
	}
}
